import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 6.png'
import ExpandIcon from '../../../images/expand copy 6.png'

class ForretningInvolvert extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleInvolvert = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var involvert = this.props.involvert
        var matrikkelnummer = `${involvert.gardsnummer}/${involvert.bruksnummer}`;
        if (involvert.festenummer || involvert.seksjonsnummer) matrikkelnummer += `/${involvert.festenummer}/${involvert.seksjonsnummer}`;
        var rolle = involvert.rolle.substr(involvert.rolle.lastIndexOf(' ')+1, involvert.rolle.length);
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleInvolvert}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{involvert.kommuneId}-{matrikkelnummer} - {rolle}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{involvert.kommunenavn} ({involvert.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('matrikkelnummer')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('rolle')}</div>
                            <div className="value">{rolle}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(ForretningInvolvert)